module.exports = __webpack_public_path__ + "static/express-shipping-6642ea26d14bcfe2a86fb24da672c711.png";